const addToString = (list) =>
  list.map((obj) => ({
    ...obj,
    toString() {
      return this.label;
    }
  }));

export default addToString;
